import { useEffect, useRef } from 'react';
import { useBeforeUnload } from 'react-router-dom';
import { GAME_DB } from '../../db/game';
import { selectCurrentTaskId, selectCurrentTaskTimeLogs, setCurrentTaskTimeLogs, } from '../../store/slices/rallyGame';
import { getAtomFormattedDate } from '../../helpers';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../store';
export const useTaskEndTimeTracker = () => {
    const dispatch = useAppDispatch();
    const currentTaskId = useSelector(selectCurrentTaskId);
    const currentTaskTimeLogs = useSelector(selectCurrentTaskTimeLogs);
    const currentTaskIdRef = useRef(currentTaskId);
    const currentTaskTimeLogsRef = useRef(currentTaskTimeLogs);
    useEffect(() => {
        currentTaskIdRef.current = currentTaskId;
        currentTaskTimeLogsRef.current = currentTaskTimeLogs;
    }, [currentTaskId, currentTaskTimeLogs]);
    const saveTimeLogs = async () => {
        const taskId = currentTaskIdRef.current;
        const taskLogs = currentTaskTimeLogsRef.current;
        if (taskId && taskLogs) {
            await GAME_DB.UPDATE.pushAnswerTimeLogs({
                task: taskId,
                startTime: taskLogs.startTime,
                endTime: getAtomFormattedDate(Date.now()),
            });
            dispatch(setCurrentTaskTimeLogs(null));
        }
    };
    useBeforeUnload(saveTimeLogs);
    useEffect(() => {
        return () => {
            saveTimeLogs().catch((err) => {
                console.error('Error saving task logs on unmount:', err);
            });
        };
    }, []);
};
